import { Modal } from "../ui/components/Modal";
import Api from "../api";

export class RenewalModal extends Modal {
    init() {
        super.init()

        this.renewalBtn.on('click', this.handleCreateAutoRenewal.bind(this))
    }

    handleCreateAutoRenewal() {
        Api.post(this.renewalBtn.create_url).then((url) => {
            window.location.href = url;
            // this.hide();
            // window.location.reload();
        })
    }
}
